import { NotationType } from '../../../shared-types/Notation/NotationType';
import {
  INotationManagementState,
  notationManagementInitialState,
} from './Interfaces/INotationManagementState';
import { NotationManagementActionType } from './types/NotationManagementActionType';
import { DispatchActions } from './types/NotationManagementDispatchActions';

export const NotationManagementReducer = (
  state: INotationManagementState,
  action: DispatchActions,
): INotationManagementState => {
  switch (action.type) {
    case NotationManagementActionType.SetNotations:
      return { ...state, notations: action.value };

    case NotationManagementActionType.SetCategories:
      return { ...state, categories: action.value };

    // case NotationManagementActionType.SetFilterNotationType:
    //   return {
    //     ...state,
    //     filters: {
    //       ...state.filters,
    //       notationTypes: action.value,
    //     },
    //     selectAll: false,
    //     selectedNotations: [],
    //   };

    case NotationManagementActionType.RemoveNotationType:
      if (state.filters.notationTypes.findIndex(x => x === action.value) !== -1)
        return {
          ...state,
          filters: {
            ...state.filters,
            notationTypes: state.filters.notationTypes.filter(
              x => x !== action.value,
            ),
          },
          selectAll: false,
          selectedNotations: [],
        };
      return state;

    case NotationManagementActionType.SetFilterCategory:
      if (
        state.filters.categories.findIndex(x => x.id === action.value.id) === -1
      )
        return {
          ...state,
          filters: {
            ...state.filters,
            categories: [action.value],
          },
          selectAll: false,
          selectedNotations: [],
        };
      return state;

    case NotationManagementActionType.RemoveCategory:
      if (
        state.filters.categories.findIndex(x => x.id === action.value.id) !== -1
      )
        return {
          ...state,
          filters: {
            ...state.filters,
            categories: state.filters.categories.filter(
              x => x.id !== action.value.id,
            ),
          },
          selectAll: false,
          selectedNotations: [],
        };
      return state;

    case NotationManagementActionType.SetCreatedBy:
      return {
        ...state,
        filters: { ...state.filters, createdBy: action.value },
        selectAll: false,
        selectedNotations: [],
      };

    case NotationManagementActionType.SetCreatedFor:
      return {
        ...state,
        filters: { ...state.filters, createdFor: action.value },
        selectAll: false,
        selectedNotations: [],
      };

    case NotationManagementActionType.SetStartDate:
      return {
        ...state,
        filters: { ...state.filters, startDate: action.value },
        selectAll: false,
        selectedNotations: [],
      };

    case NotationManagementActionType.SetEndDate:
      return {
        ...state,
        filters: { ...state.filters, endDate: action.value },
        selectAll: false,
        selectedNotations: [],
      };

    case NotationManagementActionType.DeleteNotation:
      return {
        ...state,
        notations: state.notations.filter(
          x => !(x.notationType === action.notationType && x.id === action.id),
        ),
      };

    case NotationManagementActionType.LowerAlerts:
      return {
        ...state,
        notations: state.notations.map(x => {
          if (
            action.ids.findIndex(
              y => y === x.id && x.notationType === 'Alert',
            ) !== -1
          ) {
            return { ...x, alertStatus: 'Lowered' };
          }
          return x;
        }),
      };

    case NotationManagementActionType.EditNotation:
      return {
        ...state,
        notations: state.notations.map(x =>
          x.id === action.notation.id &&
          x.notationType &&
          action.notation.notationType
            ? action.notation
            : x,
        ),
      };

    case NotationManagementActionType.SetNotationsLoading:
      return {
        ...state,
        isNotationsLoading: action.value,
      };

    case NotationManagementActionType.SetHasMoreNotation:
      return {
        ...state,
        hasMoreNotation: action.value,
      };

    case NotationManagementActionType.AssignTo:
      return {
        ...state,
        notations: state.notations.map(x => {
          if (x.id === action.id && x.notationType === NotationType.Alert) {
            return {
              ...x,
              assignedToId: action.assignTo?.id,
              assignedTo: action.assignTo,
            };
          }
          return x;
        }),
      };

    case NotationManagementActionType.Reset:
      return {
        ...notationManagementInitialState(),
        categories: state.categories,
      };

    case NotationManagementActionType.OpenLowerAlert:
      return {
        ...state,
        modalStatus: 'LowerAlert',
        focusedNotation: action.notation,
      };

    case NotationManagementActionType.OpenExpandedNotation:
      return {
        ...state,
        modalStatus: 'ExpandedNotation',
        focusedNotation: action.notation,
      };

    case NotationManagementActionType.OpenDeleteNotationConfirmation:
      return {
        ...state,
        modalStatus: 'DeleteConfirmation',
        focusedNotation: action.notation,
      };

    case NotationManagementActionType.CloseModal:
      return {
        ...state,
        modalStatus: undefined,
        focusedNotation: undefined,
      };

    case NotationManagementActionType.NotationSelected:
      if (state.selectAll) {
        if (action.selected) {
          return {
            ...state,
            excludedNotations: state.excludedNotations.filter(
              x =>
                !(
                  x.id === action.notation.id &&
                  x.notationType === action.notation.notationType
                ),
            ),
          };
        } else {
          return {
            ...state,
            excludedNotations: [...state.excludedNotations, action.notation],
          };
        }
      } else {
        if (action.selected) {
          return {
            ...state,
            selectedNotations: [...state.selectedNotations, action.notation],
          };
        } else {
          return {
            ...state,
            selectedNotations: state.selectedNotations.filter(x => {
              return !(
                x.id === action.notation.id &&
                x.notationType === action.notation.notationType
              );
            }),
          };
        }
      }

    case NotationManagementActionType.SelectAll:
      return { ...state, selectAll: true };

    case NotationManagementActionType.DeselectAll:
      return {
        ...state,
        selectAll: false,
        selectedNotations: [],
        excludedNotations: [],
      };

    case NotationManagementActionType.SetTotalNotations:
      return { ...state, totalNotations: action.value };

    case NotationManagementActionType.SetNotationFilters:
      return { ...state, filters: action.value };

    default:
      return state;
  }
};
